import { PostSkeleton } from './PostSkeleton';

/**
 * Skeleton loading state for the posts list.
 * Shows multiple post skeletons.
 */
export function PostListSkeleton() {
  return (
    <div className="space-y-6">
      {[1, 2, 3].map((index) => (
        <PostSkeleton key={index} />
      ))}
    </div>
  );
}

